module.exports = __webpack_public_path__ + "static/media/surface3.fab62f2f.svg";